__webpack_require__.p = "/shared-content/art/tncms/admin/";